import { Tooltip } from '@mui/material';
import React from 'react';
import { RequestorMapping } from '../../../common/commons';

const AllDropDownOptions = {
    "ticket_type" : ['Add-Whitelist', 'Deactivate-Account', 'ISR', 'Remove-Whitelist', 'Right-to-Correct','Right-to-Create',  'Right-to-Delete', 'Right-to-Know-Detailed', 'Right-to-OptOut','Right-to-Terminate', 'Terminate-Vehicle-Location-Access', 'Unflag-VIN'],
    "requestor" : [RequestorMapping.B2B, RequestorMapping.CUSTOMER, RequestorMapping.DRIVER, RequestorMapping.EMPLOYEE,RequestorMapping.SURVIVOR, RequestorMapping.TCICUSTOMER],
    "status" : ['Pre Open', 'Open', 'Review', 'Closed', 'Uploaded', 'Upload Failed', 'Cancelled'],
}

export const getHomePageColumns = (app_Info,advancedFilter) => {
    const getValueOptions = (type)=>{
        let options = AllDropDownOptions[type];
        if(type === "app"){
            options = app_Info?.map(({ display }) => display);
        }
        return options;
    }
    return [{
        name: "#",
        mapping: "id",
        width: 50,
        frozen: true,
        sortable: false,
        hideable: false,
        headerAlign: 'center',
        align: 'center',
    }, {
        name: "Request ID",
        mapping: "requestId",
        width: 200,
        minWidth: 180,
        frozen: true,
        sortable: false,
        hideable: false,
        // displayTootip: ["requestId"],
        renderCell: (params) => (
            <a href="void(0)" rel="noopener noreferrer" onClick={(event)=>{
                event.preventDefault();
            }}>
                {params.row["requestId"]}
            </a>
        )
    },
    {
        name: "Request Type",
        mapping: "ticket_type",
        width: 160,
        sortable: true,
        frozen: true,
        type: 'singleSelect',
        minWidth: 250,
        maxWidth: 250,
        valueOptions: getValueOptions("ticket_type"),
        customSingleSelectFilter: true,
    },
    {
        name: "Requestor",
        mapping: "requestor",
        width: 100,
        sortable: true,
        type: 'singleSelect',
        valueOptions: getValueOptions("requestor"),
        customSingleSelectFilter: true,
    },
    {
        name: "Request Status",
        mapping: "status",
        width: 120,
        sortable: true,
        type: 'singleSelect',
        valueOptions: getValueOptions("status"),
        customSingleSelectFilter: true,
    }, {
        name: "Create Date Time",
        mapping: "created_date",
        type: "date",
        sortable: true,
        valueGetter: (params) => params.value ? new Date(params.value) : null,
        renderCell: (params) => (
            <Tooltip title={params.row["createdDateandTimeLocal"]}>
                <span>
                    {params.row["createdDateandTimeUTC"]}
                </span>
            </Tooltip>
        ),
        width: 200
    }, {
        name: "DownStream Apps",
        mapping: "downstreamApps",
        sortable: false,
        valueOptions: getValueOptions("app"),
        displayTootip: ["App Name List"],
        customSingleSelectFilter: true,
        width: 250,
        maxWidth: 250,
        minWidth: 200
    }, {
        name: "VIN(s) #",
        mapping: "noOfVins",
        width: 80,
        disableColumnMenu: true,
        sortable: false,
        type: "number",
        align: 'left',
        headerAlign: 'left',
    }, {
        name: "GUID(s) #",
        mapping: "noOfGUIDS",
        width: 90,
        disableColumnMenu: true,
        sortable: false,
        type: "number",
        align: 'left',
        headerAlign: 'left',
    }, {
        name: "Cust ID(s) #",
        mapping: "noOfCustIds",
        width: 100,
        disableColumnMenu: true,
        sortable: false,
        type: "number",
        align: 'left',
        headerAlign: 'left',
    }]
}


export const getAdvancedSearchFields = (apps) => [{
    type: 'text',
    name: 'id',
    label: 'DSAR ID',
    enableTrim: true,
    handleEnterToSubmit : true
}, {
    type: 'text',
    name: 'response_contains',
    label: 'Response Contains',
    handleEnterToSubmit: true
}, {
    type: 'text',
    name: 'request_contains',
    label: 'Request Contains',
    handleEnterToSubmit: true
}, {
    type: 'multiselect',
    name: 'ticket_type',
    label: 'Request Type',
    isMulti: true,
    options: ['All', 'Add-Whitelist', 'Deactivate-Account', 'ISR', 'Remove-Whitelist', 'Right-to-Correct', 'Right-to-Create', 'Right-to-Delete', 'Right-to-Know-Detailed', 'Right-to-OptOut', 'Right-to-Terminate', 'Terminate-Vehicle-Location-Access', 'Unflag-VIN'],
    defaultOption: 'All'
}, {
    type: 'multiselect',
    name: 'status',
    label: 'Request Status',
    isMulti: true,
    options: ['All', 'Cancelled', 'Closed', 'Open', 'Pre Open', 'Review', 'Uploaded', 'Upload Failed'],
    defaultOption: 'All'
}, {
    type: 'multiselect',
    name: 'requestor',
    label: 'Requestor',
    isMulti: true,
    options: ['All', RequestorMapping.B2B, RequestorMapping.CUSTOMER, RequestorMapping.DRIVER, RequestorMapping.EMPLOYEE, RequestorMapping.SURVIVOR, RequestorMapping.TCICUSTOMER],
    defaultOption: 'All'
}, {
    type: 'multiselect',
    name: 'app',
    label: 'Downstream Apps',
    isMulti: true,
    options: ['All', ...apps?.map(({ display }) => display)],
    defaultOption: 'All'
}, {
    type: 'date',
    name: 'from_date',
    label: 'From Date'
}, {
    type: 'date',
    name: 'to_date',
    label: 'To Date'
}]

const isSurvivor = (formData) => formData?.requestor !== 'Driver';
const isDriver = (formData) => formData?.requestor === 'Driver';
export const DEACTIVATE_ACCOUNT_REQUEST_TYPE = 'Deactivate-Account';
const isDeactivateAccount = (formData) => formData?.request_type === DEACTIVATE_ACCOUNT_REQUEST_TYPE;

export const getAutoDSRCreateFields = () => [{
    type: 'multiselect',
    name: 'requestor',
    label: 'Requestor',
    required: true,
    options: ['Survivor', 'Driver'],
    defaultOption: 'Survivor',
    resetFormOnChange: true,
    size: 4
}, {
    type: 'text',
    name: 'dsar_id',
    label: 'DSAR ID',
    enableTrim: true,
    required: true,
    handleEnterToSubmit: true,
    size: 4,
    maxLength: 100
}, {
    type: 'multiselect',
    name: 'request_type',
    label: 'Request Type',
    required: true,
    options: ['Add-Whitelist', DEACTIVATE_ACCOUNT_REQUEST_TYPE, 'ISR', 'Remove-Whitelist', 'Right-to-Terminate', 'Unflag-VIN'],
    defaultOption: '',
    resetFormOnChange: true,
    preserveFieldsOnReset: ['dsar_id'],
    hiddenCallback: isDriver,
    size: 4
}, {
    type: 'text',
    name: 'request_type_driver',
    label: 'Request Type',
    required: true,
    defaultOption: 'TVLA',
    isDisabled: true,
    hiddenCallback: isSurvivor,
    size: 4,
    maxLength: 100
}, {
    type: 'text',
    name: 'first_name',
    label: 'First Name',
    required: true,
    handleEnterToSubmit: true,
    hiddenCallback: isDriver,
    size: 4,
    maxLength: 100
}, {
    type: 'text',
    name: 'last_name',
    required: true,
    label: 'Last Name',
    handleEnterToSubmit: true,
    hiddenCallback: isDriver,
    size: 4,
    maxLength: 100
}, {
    type: 'text',
    name: 'email',
    label: 'Email',
    handleEnterToSubmit: true,
    hiddenCallback: isDriver,
    size: 4,
    maxLength: 100
}, {
    type: 'text',
    name: 'vin',
    label: 'VIN',
    required: true,
    requiredCallback: (formData) => !isDeactivateAccount(formData),
    disabledCallback: isDeactivateAccount,
    handleEnterToSubmit: true,
    size: 4,
    maxLength: 17
}, {
    type: 'text',
    name: 'ccid',
    label: 'CCID',
    handleEnterToSubmit: true,
    hiddenCallback: isDriver,
    size: 4,
    maxLength: 100
}, {
    type: 'chips',
    name: 'guids',
    label: 'GUID',
    requiredCallback: isDeactivateAccount,
    handleEnterToSubmit: true,
    hiddenCallback: isDriver,
    size: 4
}, {
    type: 'text',
    name: 'tc_case_number',
    label: 'TC Case #',
    required: true,
    handleEnterToSubmit: true,
    hiddenCallback: isSurvivor,
    size: 4,
    maxLength: 20
}, {
    type: 'text',
    name: 'bec_number',
    label: 'BEC Case #',
    required: true,
    handleEnterToSubmit: true,
    hiddenCallback: isDriver,
    size: 4,
    maxLength: 20
} ]

const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const year = tomorrow.getFullYear();
    const month = String(tomorrow.getMonth() + 1).padStart(2, '0');
    const day = String(tomorrow.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const getCreatePrivateTaskFields = (users = []) => [{
    type: 'text',
    name: 'first_and_last_name',
    label: 'First and Last Name',
    required: true,
    handleEnterToSubmit: true,
    size: 3,
    maxLength: 200,
    normalizeWhitespace: true,
    allowedPattern: /^[A-Za-z\s]*$/,
    placeholder: "Enter Full Name of POC"
}, {
    type: 'text',
    name: 'email',
    label: 'Email ID',
    required: true,
    handleEnterToSubmit: true,
    size: 3,
    //maxLength: 100,
    placeholder: "Enter Email ID of POC"
}, {
    type: 'text',
    name: 'title',
    label: 'Task Title',
    required: true,
    handleEnterToSubmit: true,
    size: 3,
    maxLength: 200,
    normalizeWhitespace: true,
    allowMultipleSpaces: true,
    allowedPattern: /^[A-Za-z0-9 ,.:;-]*$/,
    placeholder: "Enter Title"
}, {
    type: 'text',
    name: 'application_or_system',
    label: 'Application or System',
    required: true,
    handleEnterToSubmit: true,
    hiddenCallback: isDriver,
    size: 3,
    maxLength: 200,
    normalizeWhitespace: true,
    allowMultipleSpaces: true,
    allowedPattern: /^[A-Za-z0-9 ,.:;-]*$/,
    placeholder: "Enter App Name"
}, {
    type: 'text',
    name: 'task_description',
    label: 'Task Description',
    required: true,
    handleEnterToSubmit: true,
    size: 3,
    //normalizeWhitespace: true,
    //maxLength: 1000,
    placeholder: "Enter description..."
}, {
    type: 'multiselect',
    name: 'task_owner',
    label: 'Task Owner',
    required: true,
    options: users.map(user => ({
        id: user.user_id,
        user_name: `${user.first_name} ${user.last_name}`
    })),
    displayOption: 'user_name',
    removeCheckBox: true,
    handleEnterToSubmit: true,
    defaultOption: '',
    size: 3,
    maxLength: 17,
    placeholder: "Select Task Owner"
}, {
    type: 'multiselect',
    name: 'priority',
    label: 'Priority',
    required: true,
    options: ['Low', 'Medium', 'High'],
    defaultOption: '',
    size: 3,
    placeholder: "Select Priority"
}, {
    type: 'multiselect',
    name: 'task_category',
    label: 'Task Category',
    required: true,
    options: ['24MM/24MMSUs', 'CCPA/CPRA Privacy Rights', 'Contracts', 'Data Access Requests', 'OneApp Consents', 'Privacy Intake Requests', 'Privacy Reviews', 'PrivacyVTS', 'Quebec Law 25', 'T&Cs-Privacy', 'Telematics Sticker'],
    defaultOption: '',
    size: 3,
    placeholder: "Select Category"
}, {
    type: 'date',
    name: 'project_kickoff_date',
    label: 'Project Kick off Date',
    size: 3,
    placeholder: 'Select Date'
}, {
    type: 'date',
    name: 'launch_date',
    label: 'Launch Date',
    size: 3,
    placeholder: 'Select Date',
    inputAdditionalProps: {
        min: getTomorrowDate()
    }
}, {
    type: 'date',
    name: 'task_due_date',
    label: 'Task Due Date',
    size: 3,
    required: true,
    placeholder: 'Select Date',
    inputAdditionalProps: {
        min: getTomorrowDate()
    }
}]